<template>
  <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
    <h2 class="heading bottom40 darkcolor font-light2">
      <span class="font-normal">Reset Password</span>
      <span class="divider-center"></span>
    </h2>
    <div class="col-md-8 offset-md-2 heading_space">
      <p>
        <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        explicabo laudantium, omnis provident quam reiciendis voluptatum? -->
      </p>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow">
    <b-overlay :show="loadingCard" rounded="sm">
      <div class="widget logincontainer">
        <h5 class="darkcolor bottom35 text-center text-md-left">
          Masukkan Password Baru
        </h5>
        <Form
          class="getin_form border-form"
          id="login"
          :validation-schema="schema"
          @submit="submitLogin"
        >
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom35">
                <label for="registerEmail" class="d-none"></label>
                <Field
                  class="form-control"
                  type="password"
                  placeholder="Password:"
                  name="password"
                  style="margin: 0px !important"
                  v-model="loginData.password"
                />
                <ErrorMessage class="text-danger" name="password" />
              </div>
              <div class="form-group bottom35">
                <label for="registerEmail" class="d-none"></label>
                <Field
                  class="form-control"
                  type="password"
                  placeholder="Konfirmasi Password:"
                  name="password_confirmation"
                  style="margin: 0px !important"
                  v-model="loginData.password_confirmation"
                />
                <ErrorMessage
                  class="text-danger"
                  name="password_confirmation"
                />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25 text-center">
                <div class="d-flex w-100 justify-content-center">
                  <RecaptchaV2
                    @widget-id="handleWidgetId"
                    @error-callback="handleErrorCalback"
                    @expired-callback="handleExpiredCallback"
                    @load-callback="handleLoadCallback"
                    language="id"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <!-- <a href="" class="defaultcolor mb-2" style="float: right"
                >Lupa Password ?</a
              > -->

              <button type="submit" class="button gradient-btn w-100">
                Submit
              </button>
              <!-- <p class="top20 log-meta">
                Belum Memiliki akun ? &nbsp;<a
                  href="/register"
                  class="defaultcolor"
                  >Daftar</a
                >
              </p> -->
            </div>
          </div>
        </Form>
      </div>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthStore } from "@/store/auth";
import { useToast, TYPE } from "vue-toastification";
import JwtService from "@/core/services/JwtService";
import { redirectAdmin } from "@/core/helpers/urls";
import { useRoute } from "vue-router";
import router from "@/router";

export default defineComponent({
  name: "LoginView",
  components: {
    Form,
    Field,
    ErrorMessage,
    RecaptchaV2,
  },
  setup() {
    const authStore = useAuthStore();
    const loadingCard = ref(false);
    const toast = useToast();
    const route = useRoute();

    const resetCode = route.query.reset_code;
    // console.log(resetCode);

    const loginData: any = reactive({
      email: "",
      password: "",
      password_confirmation: "",
      recaptcha_token: "",
      reset_code: resetCode,
    });

    const schema = yup.object({
      password: yup
        .string()
        .required("Password tidak boleh kosong !")
        .min(8, "Password minimal 8 karakter")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/,
          "Password harus mengandung huruf besar (A-Z), huruf kecil (a-z), angka (0-9), dan karakter spesial (!@#$%^&*)"
        ),
      password_confirmation: yup
        .string()
        .required("Konfirmasi password tidak boleh kosong !")
        .oneOf([yup.ref("password"), null], "Password tidak sama"),
    });

    const handleWidgetId = (widgetId: number) => {
      // console.log("Widget ID: ", widgetId);
    };
    const handleErrorCalback = () => {
      // console.log("Error callback");
      loginData.recaptcha_token = "";
    };
    const handleExpiredCallback = () => {
      // console.log("Expired callback");
      loginData.recaptcha_token = "";
    };
    const handleLoadCallback = (response: unknown) => {
      // console.log("Load callback", response);
      loginData.recaptcha_token = response;
    };

    const togglePasswordVisibility = () => {
      const password = document.getElementById("password");
      const passwordToggle = document.getElementById("password-toggle");

      if (password && passwordToggle) {
        if (password.getAttribute("type") === "password") {
          password.setAttribute("type", "text");
          passwordToggle.classList.remove("fa-eye");
          passwordToggle.classList.add("fa-eye-slash");
        } else {
          password.setAttribute("type", "password");
          passwordToggle.classList.remove("fa-eye-slash");
          passwordToggle.classList.add("fa-eye");
        }
      }
    };

    const submitLogin = async () => {
      if (loginData.recaptcha_token == "") {
        return;
      }

      authStore.logout();

    //   console.log(loginData);

      loadingCard.value = true;
      await authStore
        .resetPassword(loginData)
        .then((res) => {
          Swal.fire({
            title: "Berhasil",
            text: "Password berhasil diubah",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/login";
            }
          });
        })
        .catch((err) => {
          Swal.fire({
            title: "Gagal",
            text: err.response.data.meta.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        });

      loadingCard.value = false;
    };

    onMounted(() => {
      if (route.query.logout) {
        authStore.logout();
        window.location.href = "/login";
      }

      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
      }
    });

    return {
      loginData,
      loadingCard,
      authStore,
      toast,
      handleWidgetId,
      handleExpiredCallback,
      handleLoadCallback,
      handleErrorCalback,
      schema,
      togglePasswordVisibility,
      submitLogin,
    };
  },
});
</script>
